import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useFeatures } from 'modules/core/hooks/useFeatures'

export const useCustomCandidateSourceFeatureAvailability = () => {
  const { has_dev_packaging_paywalls, has_ats_sources_customization } = useFeatures([
    'dev_packaging_paywalls',
    'ats_sources_customization',
  ])
  const { featureAvailability } = useFeatureAvailability(Features.ats_customized_features)

  return has_dev_packaging_paywalls ? featureAvailability.available : has_ats_sources_customization
}
